import { Button, Card, CardContent, CardHeader, Grid } from "@mui/material";
import { FormProvider, RHFSelectField, RHFTextField } from "../../common/hook-form";
import { useFieldArray, useForm } from "react-hook-form";
import { useState } from "react";
import MUIModal from "../../components/MuiModal";
import { LoadingButton } from "@mui/lab";
import { apiConstants, post } from "../../common/constants";
import { useSnackbar } from "notistack";
import AddIcon from "@mui/icons-material/Add";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import BulkZoneOverride from "./BulkZoneOverride";
import UploadIcon from '@mui/icons-material/Upload';
import { MerchantFilterCached } from "../../common/ProshipFormComponents";
import PageTitle from "../../components/PageTitle";



export default function ZoneOverRide(props) {
    const { isStandalone = true } = props;
    const methods = useForm({
        defaultValues: {
            list: [
                {
                    f: "",
                    t: "",
                    z: "",
                    mi: "",
                    mx: "",
                },
            ],
        },
    });
    const { handleSubmit, control, reset, watch } = methods;
    const { fields, append, remove } = useFieldArray({
        control,
        name: "list",
    });
    const merchant = isStandalone ? watch("merchant") : props.merchant;

    const { enqueueSnackbar } = useSnackbar();
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [open, setOpen] = useState(false)

    const zone = [{
        label: "Local",
        value: "1",
    },
    {
        label: "Regional",
        value: "2",
    },
    {
        label: "Special",
        value: "5",
    },
    {
        label: "ROI",
        value: "4",
    },
    {
        label: "Metro",
        value: "3",
    }]
    const onSubmit = async (data) => {
        setIsSubmitting(true)
        await post(`${apiConstants.MERCHANT_CONFIG}/${merchant}/zones`, data?.list).then((res) => {
            if (res.status === 200) {
                enqueueSnackbar("Zone Override Successfully!", { variant: 'success' });
                reset()
            }
        }).catch((err) => console.log(err))
        setIsSubmitting(false)
    }
    return (
        <>
            {isStandalone && (<PageTitle>Zone Override</PageTitle>)}
            <Card>
                <CardHeader title='Zone Override'
                    action={
                        <>
                            <Grid sx={{ display: "flex", justifyContent: 'end', paddingRight: 2 }}>
                                <Button startIcon={<UploadIcon />} variant="contained"
                                    onClick={() => setOpen(true)} size="small" >Upload
                                </Button>
                            </Grid>
                            <MUIModal open={open} handleClose={() => setOpen(() => false)} children={<BulkZoneOverride setOpen={setOpen} />}
                                title={"Bulk Zone OverRide"} maxWidth="md" />
                        </>
                    }
                />
                <CardContent sx={{ maxHeight: 400, overflow: 'auto' }}>
                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={2}>
                            {isStandalone && (
                                <Grid item xs={12}>
                                    <MerchantFilterCached required />
                                </Grid>
                            )}
                            {fields.map((field, index) => (
                                <>
                                    <Grid item xs={6}>
                                        <RHFTextField
                                            name={`list.${index}.f`}
                                            label="From Pincode"
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <RHFTextField
                                            name={`list.${index}.t`}
                                            label="To Pincode"
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <RHFTextField
                                            name={`list.${index}.mi`}
                                            label="MIN TAT"
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <RHFTextField
                                            name={`list.${index}.mx`}
                                            label="MAX TAT"
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <RHFSelectField
                                            width="100%"
                                            name={`list.${index}.z`}
                                            label="Zone"
                                            options={zone.map((name) => ({
                                                value: name.value,
                                                label: name.label
                                            }))}
                                        />
                                    </Grid>
                                    {fields.length !== 1 && (
                                        <Grid item xs={3} sx={{ mt: 1 }}>
                                            <Button
                                                onClick={() => remove(index)}
                                                color="error"
                                                variant="contained"
                                                size="small"
                                                startIcon={<RemoveCircleOutlineIcon />}
                                            >
                                                Remove
                                            </Button>
                                        </Grid>
                                    )}
                                    {fields.length === index + 1 && (
                                        <Grid item xs={3} sx={{ mt: 1 }}>
                                            <Button
                                                onClick={() =>
                                                    append({
                                                        f: "",
                                                        t: "",
                                                        z: "",
                                                        mi: "",
                                                        mx: "",
                                                    })
                                                }
                                                variant="contained"
                                                sx={{ borderRadius: 1 }}
                                                size="small"
                                                color="warning"
                                                startIcon={<AddIcon />}
                                            >
                                                Add
                                            </Button>
                                        </Grid>

                                    )}
                                    <Grid item xs={12}>
                                        <LoadingButton
                                            loading={isSubmitting}
                                            variant="contained"
                                            size="small"
                                            type="submit"
                                            sx={{ borderRadius: 1 }}
                                        >Save</LoadingButton>
                                    </Grid>
                                </>
                            ))}

                        </Grid>
                    </FormProvider>
                </CardContent>
            </Card>
        </>
    )
}